<script setup lang="ts">
const links = [
  {
    label: "JOBS",
    to: "/suggestions",
  },
  {
    label: "PERSONEN",
    to: "/profiles",
  },
  {
    label: "MATCHES",
    to: "/matches",
  },
];

const user = useSupabaseUser();
const jobCoachName = computed(() => user.value?.user_metadata.full_name ?? "Account");
</script>

<template>
  <UHeader :links="links">
    <template #logo>
      <JobMateLogo class="h-6 w-auto" />
    </template>
    <template #right>
      <a href="/account" class="text-sm/6 font-semibold uppercase">
        {{ jobCoachName }}
      </a>
    </template>
  </UHeader>
</template>
